import Carousel from "./embla/carousel"

export default class FeaturedNews extends Carousel {
  constructor() {
    super()
    this.emblaNode = document.querySelectorAll(".featured-news .embla")

    if (!this.emblaNode.length) return

    this.emblaNode.forEach((node) => this.initCarousel(node))
  }
}
